export const baseNumberFormats = {
	short: {
		notation: 'compact',
		compactDisplay: 'short',
	},
	plain: { notation: 'standard' },
	twoDecimals: {
		notation: 'standard',
		minimumFractionDigits: 2,
		maximumFractionDigits: 2,
	},
};
